import {
    Box,
    Button,
    HStack,
    Image,
    Link,
    useBreakpointValue,
} from '@chakra-ui/react';

import React from 'react';

const languageMappings = {
    '/': '/en/',
    '/o-nama': '/en/about',
    '/generacije-svetionika': '/en/lighthouse-generations',
    '/resursi': '/en/resources',
    '/vesti': '/en/news',
    '/blog': '/en/blog-en',
    '/kontakt': '/en/contact',
    '/prijavite-se': '/en/login',
    '/404': '/en/404'
};

const LanguageSwitcher = () => {
    const isDesktop = useBreakpointValue({ base: false, lg: true });

    const handleLanguageSwitch = (lang: any) => {
        const currentPath =
            typeof window !== 'undefined' ? window.location.pathname : '';

        const normalizedPath = currentPath.replace(/\/+$/, ''); // Remove trailing slashes
        let newUrl;

        if (lang === 'en') {
            //@ts-ignore
            newUrl = languageMappings[normalizedPath] || '/en/';
        } else {
            newUrl =
                Object.keys(languageMappings).find(
                    //@ts-ignore
                    (srPath) => languageMappings[srPath] === normalizedPath
                ) || '/';
        }

        window.location.href = newUrl;
    };

    const currentPath =
        typeof window !== 'undefined' ? window.location.pathname : '';
    const isEnglish = currentPath.includes('/en/');

    return (
        <HStack spacing={4}>
            {isDesktop ? (
                <>
                    <HStack>
                        <Link
                            as="button"
                            onClick={() => handleLanguageSwitch('en')}
                            fontSize="14px"
                            fontWeight={600}
                            color="#fff"
                            _hover={{ color: 'rawSienna.500' }}
                        >
                            <Image src="/Icon/gb_flag.png" />
                        </Link>
                    </HStack>
                    <HStack>
                        <Link
                            as="button"
                            onClick={() => handleLanguageSwitch('sr')}
                            fontSize="14px"
                            fontWeight={600}
                            color="#fff"
                            _hover={{ color: 'rawSienna.500' }}
                        >
                            <Image src="/Icon/rs_flag.png" />
                        </Link>
                    </HStack>
                </>
            ) : (
                <HStack w="100%" bg="gunPowder.50" borderRadius="full" mb="24px">
                    <HStack flex="1" justifyContent="center">
                        <Button
                            w="100%"
                            bg={isEnglish ? 'rawSienna.500' : 'transparent'}
                            gap="8px"
                        >
                            <Image src="/Icon/gb_flag.png" />
                            <Link
                                as="button"
                                onClick={() => handleLanguageSwitch('en')}
                                fontSize="14px"
                                fontWeight={600}
                                color={isEnglish ? 'white' : 'rawSienna.500'}
                                _hover={{ color: 'rawSienna.500' }}
                            >
                                English
                            </Link>
                        </Button>
                    </HStack>
                    <HStack flex="1">
                        <Button
                            w="100%"
                            bg={!isEnglish ? 'rawSienna.500' : 'transparent'}
                            gap="8px"
                        >
                            <Image src="/Icon/rs_flag.png" />
                            <Link
                                as="button"
                                onClick={() => handleLanguageSwitch('sr')}
                                fontSize="14px"
                                fontWeight={600}
                                color={!isEnglish ? 'white' : 'rawSienna.500'}
                                _hover={{ color: 'rawSienna.500' }}
                            >
                                Српски
                            </Link>
                        </Button>
                    </HStack>
                </HStack>
            )}
        </HStack>
    );
};

export default LanguageSwitcher;
